export default (region, dimension, language, country) => {
  const data = allCharts[region][language][dimension]
  if (country) {
    const countryData = countryDimensionData[language][dimension]
    return {
      region: data.region,
      countries: countryData(country),
      data: ''
    }
  }
  return data
}

const countryDimensionData = {
  no: {
    forestCover: name => {
      return {
        title: `Skogdekke i ${name}`,
        subTitle: 'i kvadratkilometer fra 2000 til 2019'
      }
    },
    forestLoss: name => {
      return {
        title: `Avskoging i ${name}`,
        subTitle: 'i kvadratkilometer fra 2000 til 2019'
      }
    },
    fire: name => {
      return {
        title: `Branner i ${name}`,
        subTitle: 'Registrerte branner per dag de siste 12 månedene'
      }
    }
  },
  en: {
    forestCover: name => {
      return {
        title: `Forest cover in ${name}`,
        subTitle: 'in square kilometers from 2000 to 2019'
      }
    },
    forestLoss: name => {
      return {
        title: `Deforestation in ${name}`,
        subTitle: 'in square kilometers from 2000 to 2019'
      }
    },
    fire: name => {
      return {
        title: `Forest fires  in ${name}`,
        subTitle: 'registered fires per day for the past 12 months'
      }
    }
  }
}
// export const getChartType = (dimension, region, language, country) => {
//   const data = allCharts[region][language][dimension]
//   if (country) {
//     return {
//       region: data.region,
//       countries: data.country(country),
//       data: ''
//     }
//   }
//   return data

// }

// @TODO Temporary stuff. Need to store this data in a more meaningfull format,
// without going full CMS...
// @todo: Need to implement locales

const allCharts = {
  amazonas: {
    no: {
      forestCover: {
        region: {
          title: 'Skogdekke i Amazonas',
          subTitle: 'i kvadratkilometer fra 2000 til 2018',
          data: ''
        },
        countries: {
          title: 'Skogdekke per land',
          subTitle: 'i kvadratkilometer fra 2000 til 2018',
          data: ''
        }
      },
      forestLoss: {
        region: {
          title: 'Avskoging i Amazonas',
          subTitle: 'i kvadratkilometer fra 2000 til 2018',
          data: ''
        },
        countries: {
          title: 'Avskoging fordelt på land',
          subTitle: 'i kvadratkilometer fra 2000 til 2018',
          data: ''
        }
      },
      fire: {
        region: {
          title: 'Skogbranner i hele Amazonas',
          subTitle: 'Registrerte branner per dag de siste 12 månedene',
          data: ''
        },
        countries: {
          title: 'Skogbranner fordelt på land',
          subTitle: 'Registrerte branner per dag etter land i regionen',
          data: ''
        }
      }
    },
    en: {
      forestCover: {
        region: {
          title: 'Forest cover in the Amazon',
          subTitle: 'in square kilometers from 2000 to 2019',
          data: ''
        },
        countries: {
          title: 'Forest cover by country',
          subTitle: 'in square kilometers from 2000 to 2019',
          data: ''
        }
      },
      forestLoss: {
        region: {
          title: 'Deforestation in the Amazon',
          subTitle: 'in square kilometers from 2000 to 2019',
          data: ''
        },
        countries: {
          title: 'Deforestation by country',
          subTitle: 'in square kilometers from 2000 to 2019',
          data: ''
        }
      },
      fire: {
        region: {
          title: 'Forest fires in the Amazon',
          subTitle: 'registered fires per day for the past 12 months',
          data: ''
        },
        countries: {
          title: 'Forest fires by country',
          subTitle: 'registered fires per day by countries in the region',
          data: ''
        }
      }
    }
  },
  africa: {
    no: {
      forestCover: {
        region: {
          title: 'Skogdekke i Sentral-Afrika',
          subTitle: 'i kvadratkilometer fra 2000 til 2018',
          data: ''
        },
        countries: {
          title: 'Skogdekke per land',
          subTitle: 'i kvadratkilometer fra 2000 til 2018',
          data: ''
        }
      },
      forestLoss: {
        region: {
          title: 'Avskoging i Sentral-Afrika',
          subTitle: 'i kvadratkilometer fra 2000 til 2018',
          data: ''
        },
        countries: {
          title: 'Fordelt på land',
          subTitle: 'i kvadratkilometer fra 2000 til 2018',
          data: ''
        }
      },
      fire: {
        region: {
          title: 'Skogbranner i hele Afrika',
          subTitle: 'Registrerte branner per dag de siste 12 månedene',
          data: ''
        },
        countries: {
          title: 'Skogbranner fordelt på land',
          subTitle: 'Registrerte branner per dag etter land i regionen',
          data: ''
        }
      }
    },
    en: {
      forestCover: {
        region: {
          title: 'Forest cover in Central Africa',
          subTitle: 'in square kilometers from 2000 to 2019',
          data: ''
        },
        countries: {
          title: 'Forest cover by land',
          subTitle: 'in square kilometers from 2000 to 2019',
          data: ''
        }
      },
      forestLoss: {
        region: {
          title: 'Deforestation in Central Africa',
          subTitle: 'in square kilometers from 2000 to 2019',
          data: ''
        },
        countries: {
          title: 'Deforestation by country',
          subTitle: 'in square kilometers from 2000 to 2019',
          data: ''
        }
      },
      fire: {
        region: {
          title: 'Forest fires in  Central Africa',
          subTitle: 'registered fires per day for the past 12 months',
          data: ''
        },
        countries: {
          title: 'Forest fires by country',
          subTitle: 'registered fires per day by countries in the region',
          data: ''
        }
      }
    }
  },
  asia: {
    no: {
      forestCover: {
        region: {
          title: 'Skogdekke i Asia og Oseania',
          subTitle: 'i kvadratkilometer fra 2000 til 2018',
          data: ''
        },
        countries: {
          title: 'Fordelt på land',
          subTitle: 'i kvadratkilometer fra 2000 til 2018',
          data: ''
        }
      },
      forestLoss: {
        region: {
          title: 'Avskoging i Asia og Oseania',
          subTitle: 'i kvadratkilometer fra 2000 til 2018',
          data: ''
        },
        countries: {
          title: 'Avskoging fordelt på land',
          subTitle: 'i kvadratkilometer fra 2000 til 2018',
          data: ''
        }
      },
      fire: {
        region: {
          title: 'Skogbranner i Sør-øst Asia',
          subTitle: 'Registrerte branner per dag de siste 12 månedene',
          data: ''
        },
        countries: {
          title: 'Skogbranner fordelt på land',
          subTitle: 'Registrerte branner per dag etter land i regionen',
          data: ''
        }
      }
    },
    en: {
      forestCover: {
        region: {
          title: 'Forest cover in Asia and Oceania',
          subTitle: 'in square kilometers from 2000 to 2019',
          data: ''
        },
        countries: {
          title: 'Forest cover by country',
          subTitle: 'in square kilometers from 2000 to 2019',
          data: ''
        }
      },
      forestLoss: {
        region: {
          title: 'Deforestation in Asia and Oceania',
          subTitle: 'in square kilometers from 2000 to 2019',
          data: ''
        },
        countries: {
          title: 'Deforestation by country',
          subTitle: 'in square kilometers from 2000 to 2019',
          data: ''
        }
      },
      fire: {
        region: {
          title: 'Forest fires in Asia and Oceania',
          subTitle: 'registered fires per day for the past 12 months',
          data: ''
        },
        countries: {
          title: 'Forest fires by country',
          subTitle: 'registered fires per day by countries in the region',
          data: ''
        }
      }
    }
  }
}
